module.exports = __webpack_public_path__ + "img/1728877187763-Screenshot 34.png.f4665645.webp";